import {
  CardContainer,
  EntityGroupWorkflowCard,
  IFlow,
  flowsQuery,
  useFlowActions,
} from '@diana/core';
import { Stack, Typography, CircularProgress } from '@mui/material';
import { capitalize, noop } from 'lodash';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { WORKFLOWS_PAGE_NS } from './i18n';

export const WorkflowDraftCard = (props: {
  flow: IFlow;
  refetch: () => void;
  setProcessing: (status: boolean) => void;
}) => {
  const { t } = useTranslation(WORKFLOWS_PAGE_NS);
  const { flow } = props;
  const { imageUrl, displayName, icon } = flow;

  const editActionTitle = t('actions.continueEditing');

  const { actions } = useFlowActions({
    flowsQuery,
    ...props,
    actions: {
      edit: { title: editActionTitle },
      version: { title: t('actions.showVersion') },
    },
  });

  const editAction = actions?.find((a) => a.title === editActionTitle);

  const iconValue = { imageUrl, icon: icon?.shape ?? '', color: icon?.color ?? '' };

  return (
    <Fragment>
      <CardContainer>
        <EntityGroupWorkflowCard
          onClick={() => editAction?.onClick?.({ close: noop })}
          title={
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Typography variant="subtitle1" color="text.primary">
                {displayName || capitalize(t('titles.draftFlow'))}
              </Typography>
              {!!editAction?.loading && <CircularProgress size="1em" />}
            </Stack>
          }
          subTitle=""
          actions={actions}
          icon={iconValue}
        />
      </CardContainer>
    </Fragment>
  );
};
